import { PlacesPage } from "../places/PlacesPage";

export function SharesPage() {
  return <PlacesPage mode="shares" />;
}

